import { IllegalStateException } from "@/shared/IllegalStateException";
export function checkIsDefined(value, message) {
    if (value == null)
        throw new IllegalStateException(message);
    return value;
}
